// ** Reactstrap import
import { Card, CardBody } from "reactstrap";

// ** Utils
import { storageUrl, placeholderIcon } from "@utils";

// ** Skeleton
import SkeletonLoading from "@components/skeleton";

const HowItWorksCard = ({ item, loading }) => {
  return (
    <Card className="shadow-none">
      <div className="how-it-works__steps__img-container">
        {loading ? (
          <div className="w-100">
            <SkeletonLoading height={120} />
          </div>
        ) : (
          <img
            src={
              item.image
                ? `${storageUrl}/howitworks/${item.image}`
                : placeholderIcon
            }
            onError={(e) => (e.target.src = placeholderIcon)}
            alt={item.summary}
          />
        )}
      </div>

      <CardBody className="text-center px-0 mt-n75">
        {loading ? (
          <SkeletonLoading count={2} />
        ) : (
          <p className="text-body mt-1 mb-0">{item.summary}</p>
        )}
      </CardBody>
    </Card>
  );
};

export default HowItWorksCard;
